import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class EmailTemplateService {

  baseUrl = environment.baseUrl;

  email_template_form: FormGroup = new FormGroup({
    id: new FormControl(null),
    site_id: new FormControl('', Validators.required),
    temp_title: new FormControl('', Validators.required),
    temp_content: new FormControl('', Validators.required),
  });

  constructor(
    private http: HttpClient,) { }

  populateForm(rowData: any) {
    //this.email_template_form.setValue(rowData);
    this.email_template_form.setValue(_.omit(rowData, 'user_id', 'created_at', 'updated_at'));
  }

  get_email_templates() {
    return this.http.get(this.baseUrl + '/get_email_templates');
  }

  insert_email_template(formData: any) {
    return this.http.post(this.baseUrl + '/create_email_template', {
      site_id: formData.site_id,
      temp_title: formData.temp_title,
      temp_content: formData.temp_content,
    });
  }

  update_email_template(formData: any) {
    return this.http.post(this.baseUrl + '/update_email_template', {
      id: formData.id,
      site_id: formData.site_id,
      temp_title: formData.temp_title,
      temp_content: formData.temp_content,
    });
  }

}
